export default "__VITE_ASSET__uUHHOq20__"